import styled, { keyframes } from "styled-components";
import { useTranslation } from "../../hooks/useTranslation";

// ─── Animations ─────────────────────────────────────────────────────────────

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const slideUp = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
`;

// ─── Styled components ───────────────────────────────────────────────────────

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.25s ease;
`;

const Spinner = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 3px solid #e5e7eb;
  border-top-color: #111;
  animation: ${spin} 0.75s linear infinite;
  margin-bottom: 28px;
`;

const Content = styled.div`
  text-align: center;
  animation: ${slideUp} 0.35s ease;
`;

const Title = styled.p`
  font-size: 17px;
  font-weight: 600;
  color: #111;
  margin: 0 0 8px;
  letter-spacing: -0.01em;
`;

const Sub = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`;

const TxnId = styled.p`
  margin-top: 20px;
  font-size: 12px;
  color: #9ca3af;
  font-family: monospace;
`;

// ─── Component ───────────────────────────────────────────────────────────────

const NeoProcessingOverlay = ({ show, heading, content, transactionId }) => {
  const { t } = useTranslation();

  if (!show) return null;

  const title = heading || t("modals.paymentProcessing.title") || "Processing your payment…";
  const sub   = content || t("modals.paymentProcessing.message") || "Please wait — this only takes a moment.";

  return (
    <Overlay role="status" aria-live="polite">
      <Spinner aria-hidden="true" />
      <Content>
        <Title>{title}</Title>
        <Sub>{sub}</Sub>
        {transactionId && <TxnId>{transactionId}</TxnId>}
      </Content>
    </Overlay>
  );
};

export default NeoProcessingOverlay;
